var IconPosition;
(function (IconPosition) {
    IconPosition["Left"] = "LEFT";
    IconPosition["NoIcon"] = "NO_ICON";
    IconPosition["Right"] = "RIGHT";
})(IconPosition || (IconPosition = {}));

export { IconPosition };
//# sourceMappingURL=types.js.map
